const generateShortId = (): string => {
  // TODO maybe replace with uuid
  const shortId = Math.random().toString(36).slice(2);
  return shortId;
};

export default generateShortId;
